var allUploadedFiles = [];
var numberOfUploadedFiles = 0;
var numberOfNetworkRequests = 0;
var errorsToShow = '';
var pickClicked = false;
var uploaderActive = false;

$(function() {
    if (typeof postSize !== 'undefined') {
        postSize();
        $('a[href]').each(function() {
            this.href = this.href + document.location.hash;
        });
    }

    $('#submit_user_info').click(function(e) {
        e.preventDefault();
        if (!shouldShowUploader()) {
            $('#pixlee_uploader_error').text(errorsToShow);
            $('#pixlee_uploader_error').show();
            if (typeof postSize !== 'undefined') {
                postSize();
            }
        } else {
            $('#pixlee_upload_user_info').hide();
            $('#pixlee_uploader_error').hide();
            $('#dz').show();

        }
    });
    // Button handlers
    $('#agree_terms_link').click(function(e) {
        e.preventDefault();
        if ($('#terms').is(':visible')) {
            $('#terms').hide();
            if (typeof postSize !== 'undefined') {
                postSize();
            }
        } else {
            $('#terms').show();
            if (typeof postSize !== 'undefined') {
                postSize();
            }
        }
    });
    $('#agree_terms_hide').click(function(e) {
        e.preventDefault();
        $('#terms').hide();
        if (typeof postSize !== 'undefined') {
            postSize();
        }
    });

    // Handle file upload clicked
    $('#dz').click(function(e) {
        e.preventDefault();
        if (!pickClicked) {
            if (typeof easySocket != 'undefined') {
                var obj = JSON.stringify({
                    msg: 'render',
                    height: 630
                });
                easySocket.postMessage(obj);
            }

            $('html, body').css('height', '100%');
            uploaderActive = true;
            pickClicked = true;
            openFileDialog();
        }

    });

    // Handle cancel
    $('#pixlee_uploaded_cancel_uploaded_photos').click(function() {
        goBackAndDeleteSubmittedFiles();
    });

    //Submit button handler
    $('#pixlee_uploaded_submit_uploaded_photos').click(function() {
        if ($('#agree_terms').is(':checked')) {
            if (allUploadedFiles.length > 0) {
                if (numberOfNetworkRequests == 0) {
                    $('#pixlee_uploader_error').text('Thank you!');
                    $('#pixlee_uploader_error').show();

                    // TUCKER HACK
                    var params = [
                        'height=' + screen.height,
                        'width=' + screen.width,
                        'fullscreen=yes' // only works in IE, but here for completeness
                    ].join(',');
                    if (ALBUMID == 6624 || ALBUMID == 6623) {
                        window.open('https://docs.google.com/forms/d/15jrpOzjVG25kkkwFYCc5vv1zFHvb-bzV8S5LlArAVt0/viewform?c=0&w=1&usp=mail_form_link', '_blank', params);
                    }

                    goBack();
                } else {
                    $('#pixlee_uploader_error').text('Please wait a moment while we finish saving your photos');
                    $('#pixlee_uploader_error').show();
                }
            } else {
                $('#pixlee_uploader_error').text('No image to upload');
                $('#pixlee_uploader_error').show();
            }
        } else {
            $('#pixlee_uploader_error').text('You must agree to the terms and conditions before submitting');
            $('#pixlee_uploader_error').show();
        }
    });

    // Delete handler
    $('body').on('click', 'a.pixlee_uploaded_image_delete', function() {
        deletePhoto($(this).data('album-photo-id'));
    });

    $('body').on('change blur keyup', 'textarea.photo_title_text_area', function() {
        updateCaption($(this).val(), $(this).data('album-photo-id'));
    });
});

function goBack() {
    if (numberOfNetworkRequests.length > 0) {
        alert('Still doing some last second saving. Please wait one moment');
    } else {
        if (typeof easySocket != 'undefined') {
            var obj = JSON.stringify({
                msg: 'goBack'
            });
            easySocket.postMessage(obj);
        } else {
            window.location.href = backPath;
        }
    }
}

function goBackAndDeleteSubmittedFiles() {
    if (allUploadedFiles.length > 0) {
        numberOfNetworkRequests = 1;
        //Get all the photos and delete them
        $.ajax({
            url: cancelURL,
            type: 'post',
            data: {
                'photo_ids': allUploadedFiles
            },
            dataType: 'json',
            success: function(response) {
                numberOfNetworkRequests = 0;
                goBack();
                if (typeof easySocket != 'undefined') {
                    var obj = JSON.stringify({
                        msg: 'deleteAllPhotos',
                        response: response
                    });
                    easySocket.postMessage(obj);
                }
            }
        });
    } else {
        goBack();
    }
}

function shouldShowUploader() {
    errorsToShow = '';
    if ($('#email_capture').length > 0) {
        var capturedEmail = $('#email_capture').val();
        if (!validateEmail(capturedEmail)) {
            errorsToShow += 'Please enter a valid email ';
        } else {
            errorsToShow += '';
        }
    }
    if ($('#first_name').length > 0) {
        var capturedField = $('#first_name').val();
        if (capturedField == '') {
            errorsToShow += 'Please enter first name ';
        } else {
            errorsToShow += '';
        }
    }
    if ($('#last_name').length > 0) {
        var capturedField = $('#last_name').val();
        if (capturedField == '') {
            errorsToShow += 'Please enter last name ';
        } else {
            errorsToShow += '';
        }
    }
    if (errorsToShow == '') {
        return true;
    } else {
        return false;
    }
}

function updateCaption(newCaption, albumPhotoId) {
    numberOfNetworkRequests = numberOfNetworkRequests + 1;
    $.ajax({
        url: updateURL,
        data: {
            'id': albumPhotoId,
            'title': newCaption
        },
        type: 'put',
        dataType: 'json',
        success: function(response) {
            if (response.error_code == 0) {
                numberOfNetworkRequests = numberOfNetworkRequests - 1;
            }
            if (typeof easySocket != 'undefined') {
                var obj = JSON.stringify({
                    msg: 'updatedCaption',
                    response: response
                });
                easySocket.postMessage(obj);
            }
        }
    });
}

function deletePhoto(photoID) {
    numberOfNetworkRequests = numberOfNetworkRequests + 1;
    var payload = new Array();
    payload[0] = photoID;
    $.ajax({
        url: cancelURL,
        type: 'post',
        data: {
            'photo_ids': payload
        },
        dataType: 'json',
        success: function(response) {
            numberOfNetworkRequests = numberOfNetworkRequests - 1;
            numberOfUploadedFiles = numberOfUploadedFiles - 1;
            adjustButtonText(numberOfUploadedFiles);
            $('#' + photoID).fadeOut(function() {
                $('#' + photoID).remove();
            });
            if (typeof easySocket != 'undefined') {
                var obj = JSON.stringify({
                    msg: 'deletedPhoto',
                    response: response
                });
                easySocket.postMessage(obj);
            }
        }
    });
}


function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

// Step 1
function openFileDialog() {
    numberOfNetworkRequests = numberOfNetworkRequests + 1;
    // Create an amazon key for the file
    var theKey;
    $.ajax({
        url: createURL,
        type: 'POST',
        dataType: 'json',
        async: false,
        success: function(retdata) {
            numberOfNetworkRequests = numberOfNetworkRequests - 1;
            theKey = retdata.path;
            pickClicked = false;
            setTimeout(function() {
                filepicker.pickAndStore({
                        mimetypes: ['image/*'],
                        container: 'modal',
                        services: ['COMPUTER', 'INSTAGRAM', 'FACEBOOK', 'DROPBOX', 'GMAIL', 'FLICKR', 'URL']
                    }, {
                        path: theKey,
                        access: 'public'
                    },
                    //Success
                    function(InkBlobs) {
                        // Call confirm to start generating thumbnails etc
                        confirmFileUpload(InkBlobs[0]);
                        // Adjust the button count
                        numberOfUploadedFiles = numberOfUploadedFiles + 1;
                        adjustButtonText(numberOfUploadedFiles);
                        // Show confirm and stuff
                        $('#pixlee_submit_terms').show();
                        $('#pixlee_uploaded_submit_cancel_desktop').show();
                    },
                    function(FPError) {
                        uploaderActive = false;
                        if (typeof t != 'undefined') {
                            t();
                        }
                    }
                );
            }, 50);
        }
    });
}

// Step 2
function confirmFileUpload(blob) {
    numberOfNetworkRequests = numberOfNetworkRequests + 1;
    $.ajax({
        url: confirmURL,
        type: 'POST',
        dataType: 'json',
        data: {
            photo_key: blob.key,
            type: blob.mimetype,
            size: blob.size,
            album_id: ALBUMID,
            email_address: $('#email_capture').val(),
            'custom[first_name]': $('#first_name').val(),
            'custom[last_name]': $('#last_name').val()
        },
        success: function(response) {
            $('body').css('height', '');
            uploaderActive = false;
            numberOfNetworkRequests = numberOfNetworkRequests - 1;
            allUploadedFiles.push(response.album_photo_id);
            showImage(response);
            if (typeof t != 'undefined') {
                t();
            }
            if (typeof easySocket != 'undefined') {
                var obj = JSON.stringify({
                    msg: 'fileUploaded',
                    response: response
                });
                easySocket.postMessage(obj);
            }

        }
    });
}

// Step 3
function showImage(image) {
    var imageID = 'image_' + image.album_photo_id;
    $('#pixlee_uploaded_caption').append('<div class="pixlee_uploaded_caption_block" id="' + image.album_photo_id + '"><a data-album-photo-id="' + image.album_photo_id + '" class="pixlee_uploaded_image_delete"></a><div class="pixlee_uploaded_image_holder"><img id=' + imageID + ' src=' + image.url + '></div><textarea data-album-photo-id="' + image.album_photo_id + '" class="photo_title_text_area" placeholder="Write a description.."></textarea></div>');
    if (typeof postSize !== 'undefined') {
        postSize();
    }
    setTimeout(function() {
        $('#' + imageID).attr('src', $('#' + imageID).attr('src') + '?' + Math.random());
    }, 5000);

    setTimeout(function() {
        $('#' + imageID).attr('src', $('#' + imageID).attr('src') + '?' + Math.random());
    }, 10000);

    setTimeout(function() {
        $('#' + imageID).attr('src', $('#' + imageID).attr('src') + '?' + Math.random());
    }, 15000);
}

function adjustButtonText(numberOfUploadedFiles) {
    var text = '';
    if (numberOfUploadedFiles == 0) {
        text = 'pick photo';
    } else {
        text = 'pick another photo';
    }
    $('#dz').text(text);
}